import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the element matching the current #hash (settings search deep links).
 * `ready` lets pages wait until their content has finished loading.
 */
export function useSectionHashScroll(ready: boolean = true) {
  const { hash } = useLocation();

  useEffect(() => {
    if (!ready || !hash) return;
    const id = hash.replace("#", "");
    const timer = window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
    return () => window.clearTimeout(timer);
  }, [hash, ready]);
}
